module.exports = __webpack_public_path__ + "static/media/YB5M15_0.ec32808d.jpg";